import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegistraturaOnlineComponent } from './registratura-online.component';

const routes: Routes = [
    {
        path: '',
        component: RegistraturaOnlineComponent,
        data: {
            title: 'Registratura Online'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class RegistraturaOnlineRoutingModule { }
